import { Component, OnInit } from "@angular/core";
import { Validators, FormBuilder } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastService } from "ng-uikit-pro-standard";
import { AppConfig } from "src/app/config";
import { DataService } from "src/app/data.service";
import { GUID } from "src/app/guid";

@Component({
  selector: "app-sectionrootnew",
  templateUrl: "./sectionrootnew.component.html",
  styleUrls: ["./sectionrootnew.component.scss"],
})
export class SectionrootnewComponent implements OnInit {
  guid: GUID;

  isLoading = false;
  isError = false;
  errorMessage = "";
  id = "";
  mode = "new";
  actionForm = this.formBuilder.group({
    type: [""],
    name: ["", Validators.required],
    section: [""],
    description: [""],
    active: [true],
    successmessage: [""],
    iconname:[""],
    sequence:[]

  });

  types = [
    { value: "section", label: "Section" },
    { value: "root", label: "Root" },
  ];
  sectionRootId: string;
  errMessage: any;
  sectionRoot: any;
  allSection: any;
  sections: any[];
  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastService,
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private appConfig: AppConfig
  ) {}

  ngOnInit() {
    this.guid = new GUID();
    this.route.queryParams.subscribe((params) => {
      this.sectionRootId = this.route.snapshot.params.id;
      this.mode = this.route.snapshot.params.mode;
    });
    this.getSectionRoot();
    console.log(this.mode);
    if (this.mode.toLocaleLowerCase() == "edit") {
      // this.actionForm.controls.type.disable();
      this.getSectionRootById();
    }
    if (this.mode.toLocaleLowerCase() == "new") {
      this.actionForm.controls.type.enable();
    }
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  cancel() {
    this.router.navigateByUrl("home/sectionrootlist");
  }

  getSectionRootById() {
    return new Promise((resolve, reject) => {
      console.log("getSectionRootById");

      // alert(id)
      const id = this.sectionRootId;
      const organizationid = localStorage.getItem("crm_orgid");

      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      this.isLoading = true;
      this.dataService
        .getSectionRootById(domain, subdomain, organizationid, id)
        .subscribe(
          (res) => {
            console.log("res", res);

            if (res.success == 1) {
              this.sectionRoot = res.data.sectionroot[0];
              console.log("Doneeee****", this.sectionRoot);

              if (this.sectionRoot != null) {
                this.actionForm.controls["name"].setValue(
                  this.sectionRoot.name
                );
                this.actionForm.controls["type"].setValue(
                  this.sectionRoot.type
                );
                this.actionForm.controls["section"].setValue(
                  this.sectionRoot.sectionid || ""
                );
                this.actionForm.controls["iconname"].setValue(
                  this.sectionRoot.iconname
                );
                this.actionForm.controls["sequence"].setValue(
                  this.sectionRoot.sequence
                );
              }

              this.isLoading = false;
            } else {
              console.log("Error while saving");
              this.isLoading = false;
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.errorMessage = err.message;
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        );
    });
  }
  getSectionRoot() {
    return new Promise((resolve, reject) => {
      console.log("getSectionRoot");

      // alert(id)
      const organizationid = localStorage.getItem("crm_orgid");
      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      this.isLoading = true;
      this.dataService
        .getAllSectionRoot(domain, subdomain, organizationid)
        .subscribe(
          (res) => {
            console.log("res", res);

            if (res.success == 1) {
              this.allSection = res.data.sectionroot;
              console.log("Doneeee****", this.allSection);

              var secArr = [];
              //just add an empty entry sice this field is optional
              // secArr.push({ value: "", label: "--None--" });
              for (let i = 0; i < this.allSection.length; i++) {
                if (this.allSection[i].type.toLocaleLowerCase() == "section") {
                  secArr.push({
                    value: this.allSection[i].id,
                    label: this.allSection[i].name,
                  });
                }
              }
              this.sections = secArr;

              this.isLoading = false;
            } else {
              console.log("Error while retrieving");
              this.isLoading = false;
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.errorMessage = err.message;
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        );
    });
  }

  save() {
    if (this.actionForm.controls["name"].value.toString().trim() == "") {
      this.showWarning("Name is mandatory");
      return;
    }
    if (this.actionForm.controls["type"].value.toString().trim() == "") {
      this.showWarning("Type is mandatory");
      return;
    }
    if (
      this.actionForm.controls["type"].value.toString().trim() == "root" &&
      this.actionForm.controls["section"].value.toString().trim() == ""
    ) {
      this.showWarning("Section is mandatory");
      return;
    }

    console.log("mode", this.mode);
    if (this.mode.toLowerCase() == "new") {
      this.sectionRootId = this.guid.getGUID("sectionroot");
    }

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      // profileid: userDetail.profileid,
      // profilename: userDetail.profilename,
      data:{
        sectionroot: {
          id: this.sectionRootId,
          mode: this.mode,
          name: this.actionForm.controls["name"].value.trim(),
          type: this.actionForm.controls["type"].value.trim(),
          iconname: this.actionForm.controls["iconname"].value.trim(),
          sectionid: this.actionForm.controls["section"].value.trim()|| "",
          sequence:this.actionForm.controls["sequence"].value
        },
      },
    };


    console.log(postOption);
    this.isLoading = true;
    this.dataService.upsertSectionRoot(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl("home/sectionrootlist");
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
